import React from 'react'

import Input from 'Components/Input'

export default class TextArea extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Input disabled={this.props.disabled} title={this.props.title} onChange={this.props.onChangeInput}
             multiLine={true} rows={2}
             value={this.props.data} id={this.props.name}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/Other/TextArea.js